var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9622 1.43735C29.4306 1.43736 1.43728 29.4307 1.43728 63.9622C1.43728 98.4938 29.4306 126.487 63.9622 126.487C98.4937 126.487 126.487 98.4938 126.487 63.9622C126.487 29.4307 98.4937 1.43735 63.9622 1.43735Z",
    stroke: "#F78524",
    strokeWidth: 2.87471
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9627 10.5873C34.4846 10.5873 10.5878 34.4841 10.5878 63.9622C10.5878 93.4403 34.4846 117.337 63.9627 117.337C93.4409 117.337 117.338 93.4403 117.338 63.9622C117.338 34.484 93.4409 10.5873 63.9627 10.5873Z",
    fill: "#F78524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9631 89.8879L63.9631 53.2879",
    stroke: "white",
    strokeWidth: 7.18677,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.9633,
    cy: 41.0875,
    r: 4.57499,
    transform: "rotate(180 63.9633 41.0875)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.5397b59da8e274b3202fdf9c85587f1c.svg";
export { ForwardRef as ReactComponent };